export const httpResolver = {
  safeUrlResolver: false, // this is merged with the default http resolver in json-schema-ref-parser
};
